/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import moment, { Moment } from 'moment'
import React, { useState, useEffect } from 'react'
// import DatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css'
import { TimeSpan } from 'plugin-generic-components/shared/components/components'
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import {
    TimeSpanContainer,
    TimeInput,
    TimeSelectList,
    SaveBar,
    SaveButton,
    CancelButton,
    ConfigHeaderTimespanContainer
} from './styles'

interface IProps {
    // setTime: (k: string | null) => void
    setStartDay: (k: string | null) => void
    setEndDay: (k: string | null) => void
    setStartHour: (k: string | null) => void
    setEndHour: (k: string | null) => void
    generateAuditReport: () => void
    startDay?: string | null
    endDay?: string | null
    startHour?: string | null
    endHour?: string | null
    // time?: string | null
}

type ISelectedDate = any

export const ConfigHeaderTimespan: React.FC<IProps> = ({
    // setTime,
    setStartDay,
    setStartHour,
    setEndDay,
    setEndHour,
    generateAuditReport,
    startDay,
    startHour,
    endDay,
    endHour
}) => {
    const [show, setShow] = React.useState<boolean>(false)
    const dropdownRef = React.useRef<HTMLDivElement>(null)
    const [startDate, setStartDate] = useState<Moment>()
    const [endDate, setEndDate] = useState<Moment>()
    // const [startD, setStartD] = useState<string>('')
    // const [startH, setStartH] = useState<string>('')
    // const [endD, setEndD] = useState<string>('')
    // const [endH, setEndH] = useState<string>('')

    // const [selectedDate, setSelectedDate] = useState<ISelectedDate>(moment())

    const [canGenerateAudit, setCanGenerateAudit] = useState<boolean>(false)

    const onClear = (): void => {
        // setTime(null)
        setStartDay(null)
        setStartHour(null)
        setEndDay(null)
        setEndHour(null)
        setStartDate(null)
        setEndDate(null)
    }

    const onDateValidation = (): void => {
        if (moment(startDate).isAfter(endDate)) {
            return globalNotification.error('End date must be greater than the start date.')
        }

        if (!moment(startDate).isValid || !moment(endDate).isValid) {
            return globalNotification.error(
                'Invalid date. Please follow the YYYY/MM/DD pattern for dates and hh:mm for time.'
            )
        }

        setStartDay((startDate as Moment).format('YYYY/MM/DD').toString())
        setStartHour((startDate as Moment).format('HH:mm').toString())
        setEndDay((endDate as Moment).format('YYYY/MM/DD').toString())
        setEndHour((endDate as Moment).format('HH:mm').toString())
        // setCanGenerateAudit(true)
        generateAuditReport()
    }

    useEffect(() => {
        function handleMouseDownAction(this: Document, ev: MouseEvent): void {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(ev.target as HTMLElement) &&
                !(ev.target as HTMLElement).className.includes('Select-option')
            ) {
                setShow(false)
            }
        }

        document.addEventListener('mousedown', handleMouseDownAction)

        return () => {
            document.removeEventListener('mousedown', handleMouseDownAction)
        }
    }, [])
    useEffect(() => {
        if (startDate) {
            setStartDay((startDate as Moment).format('YYYY/MM/DD').toString())
            setStartHour((startDate as Moment).format('HH:mm').toString())
        }
    }, [startDate])

    useEffect(() => {
        if (endDate) {
            setEndDay((endDate as Moment).format('YYYY/MM/DD').toString())
            setEndHour((endDate as Moment).format('HH:mm').toString())
        }
    }, [endDate])

    // useEffect(() => {
    //     if (canGenerateAudit) {
    //         generateAuditReport()
    //         setCanGenerateAudit(false)
    //     }
    // }, [canGenerateAudit])

    return (
        <ConfigHeaderTimespanContainer ref={dropdownRef}>
            <div
                className="configheaderfilter-clickable"
                onClick={() => {
                    setShow(old => !old)
                }}
                id="systemAudit-configHeaderTimespan-clickable"
            >
                <div className="label">
                    <i className="far fa-link"></i>
                    {startDay && startHour && endDay && endHour
                        ? `${startDay} ${startHour} ${i18n('to')} ${endDay} ${endHour}`
                        : i18n('SELECT THE TIMESPAN')}
                </div>
                <i className={`${show ? 'fas fa-caret-up' : 'fas fa-caret-down'}`} />
            </div>
            <TimeSpanContainer style={{ visibility: show ? 'visible' : 'hidden' }}>
                <TimeSpan startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />
                <SaveBar>
                    <SaveButton
                        className={`btn-lg btn-bold save  ${!startDate || !endDate ? 'disabled' : ''}`}
                        disabled={!startDate || !endDate}
                        onClick={() => onDateValidation()}
                        id="systemAudit-configHeaderTimespan-applyButton"
                    >
                        {i18n('Apply')}
                    </SaveButton>
                    <CancelButton
                        className="btn-lg btn-bold cancel"
                        type="button"
                        onClick={onClear}
                        id="systemAudit-configHeaderTimespan-clearButton"
                    >
                        {i18n('Clear')}
                    </CancelButton>
                </SaveBar>
            </TimeSpanContainer>
        </ConfigHeaderTimespanContainer>
    )
}
